export default __webpack_public_path__ + "static/media/folder-icon.4d38e50f.svg";